import React from "react";
import { Tooltip } from "@paylixecommerce/shared/components";
import { MoreInfo } from "../../entrypoints/dashboard/layouts/dashboard/sidebar/icons/icons/icons";


const SimpleSelect = ({ showEmpty = false, label, disabled, style, tooltip, options, wrapperClassName, noteUnder, name, nowrap, className, placeholder, handleChange, onChange, values, note, touched, errors }) => {

	let isError = errors[name] && touched[name];

	return <div className={`${wrapperClassName ? wrapperClassName : ""} mb-4`}>
		{label && <label className={`paylixecommerce-label ${nowrap ? 'text-nowrap' : ''}`} htmlFor={name}>{label}</label>}
		{tooltip &&
			<span className="ml-1">
				<Tooltip tooltipText={tooltip} name={name} >
					<MoreInfo />
				</Tooltip>
			</span>
		}
		{note && !noteUnder && <p className="paylixecommerce-note">{note}</p>}

		<select
			style={style}
			id={name}
			name={name}
			value={values[name]}
			disabled={disabled ? "disabled" : ""}
			className={`paylixecommerce-select ${className} ${isError && 'is-invalid'}`}
			placeholder={placeholder}
			onChange={(e) => {
				if(onChange) {
					onChange(e)
				}
				handleChange(e)
			}}>
			{showEmpty ? <option value="" disabled hidden>Select</option> : null}
				{(options && typeof options === 'object') ? 
				Object.values(options).map(({ value, label }, key) => (
					<option key={key} value={value}>{label}</option>
				)) 
				: null
			}
		</select>

		{isError && <div className="invalid-feedback">{errors[name]}</div>}
		{note && noteUnder && <p className="paylixecommerce-note">{note}</p>}
	</div>
}

export default SimpleSelect;
